import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssessmentsRoutingModule } from './assessments-routing.module';
import { AssessmentsComponent } from './assessments/assessments.component';
import { PostAssessmentComponent } from './assessments/post-assessment.component';
import { AssessmentsService } from './services/assessments.service';
import { RouterModule } from '@angular/router';
import { HomeService } from '../home/services/home.service';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
  imports: [CommonModule, SharedModule, AssessmentsRoutingModule, AssessmentsComponent, PostAssessmentComponent],
  providers: [AssessmentsService, HomeService],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AssessmentsModule {}
